import React from 'react';
import { MdOutlinePayments } from 'react-icons/md';

export default function Subscriptions() {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen w-full">
      <div className="text-center p-8 max-w-md mx-auto">
        <MdOutlinePayments 
          className="mx-auto text-gray-400" 
          size={48} 
          aria-hidden="true"
        />
        <p className="mt-4 text-gray-400 text-lg font-medium">
          No active subscriptions at the moment!
        </p>
      </div>
    </div>
  );
}